import { BACKEND_DOMAIN } from "utils/constants";
import { request } from "graphql-request";
import { graphql } from "gql/gql";
import { buildRequestHeaders } from "utils/helpers";
import { RemodelBuildingModelsMutation } from "gql/graphql";

const mutationRemodelBuildingModel = (
  accessToken: string, buildingModelUids: string[]
) => request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: {
            buildingModelUids,
        },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data: RemodelBuildingModelsMutation) => {
        const errors = data.remodelBuildingModels
            .map((response) => response.error)
            .filter((error) => error !== null && error !== undefined);

        if (errors.length > 0) {
            const errorString = errors.map((error) => `• ${error}`).join("\n");
            throw new Error(errorString);
        }
        return data.remodelBuildingModels;
    });

const query = graphql(`
    mutation remodelBuildingModels($buildingModelUids: [Uuid!]!) {
        remodelBuildingModels(buildingModelUids: $buildingModelUids) {
            success
            error
        }
    }
`);

export default mutationRemodelBuildingModel;
